import { fontSize } from '../constants';

export const getNewDomain = (container, entity, valueKey = 'value') => {
  const offsetWidth = container.offsetWidth;
  const paddingHoriz = 23 * 2;
  const plotMargin = 5 * 2;
  const plotWidth = offsetWidth - plotMargin - paddingHoriz;

  // Добавляется 3, чтобы примерно покрыть оставшееся пространство для обводки, тире и пробелов.
  const value = entity[valueKey];
  const nameLength = entity.name.length;
  const valueLength = value?.toString().length;

  const labelLength = (nameLength + valueLength + 3) * fontSize;

  const ratio = labelLength / plotWidth;

  const val = typeof value === 'string' || value === 0 ? 0.1 : value;

  const newDomain = val + val * ratio;

  return newDomain;
};
